/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SetKSBoosterSettingsRequest = {
  bonusType: SetKSBoosterSettingsRequest.bonusType;
};

export namespace SetKSBoosterSettingsRequest {
  export enum bonusType {
    SPEED_BOX = 'SpeedBox',
    KLONDIKE = 'Klondike',
  }
}
